import { useRouteError } from "react-router-dom";
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import PublicOffIcon from '@mui/icons-material/PublicOff';
import './errorPage.css'

const ErrorPage = ({customStatusText, type}) => {
  const error = useRouteError();
  // console.error(error);

  return (
    <div id="error-page">
      { type === 'error' ?
        <>
        <ErrorOutlineIcon sx={{ fontSize: 50, mt: 2 }} />
        <p>Sorry, an unexpected error has occurred.</p>
        </>
        :
        <PublicOffIcon sx={{ fontSize: 50, mt: 2 }} />
      }
      { error &&
        <p>
          <i>{error.statusText || error.message}</i>
        </p>
      }
      { customStatusText &&
        <p>
          <i>{customStatusText}</i>
        </p>
      }
    </div>
  );
}

export default ErrorPage;
